import React from 'react';
import { Modal, Descriptions } from 'antd';

import { DeviceTypeCertificates } from '@services/types';

interface Props {
  certificate: DeviceTypeCertificates;
  visible: boolean;
  onClose: VoidFunction;
}

const CertificateInfoModal: React.FC<Props> = ({ certificate, visible, onClose }) => {
  return (
    <Modal visible={visible} title="Certificate Info" okText="Ok" onCancel={onClose} onOk={onClose}>
      <Descriptions style={{ maxHeight: '300px', overflow: 'scroll' }} layout="vertical">
        <Descriptions.Item label="Common Name">{certificate.etc.commonName}</Descriptions.Item>
        <Descriptions.Item label="Certificate Content">{certificate.data}</Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default React.memo(CertificateInfoModal);
